<template>
  <el-dialog
    title="非券订单佣金明细"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    width="1000px"
    custom-class="non-coupon-commission-detail-dialog"
    @closed="resetState"
  >
    <div v-if="dataUpdateTime" class="commission-detail__update-time">
      数据更新时间：{{ dataUpdateTime }}
    </div>

    <el-table
      :data="tableList.list"
      v-loading="loading"
      border
      highlight-current-row
      style="width: 100%"
    >
      <el-table-column label="月份" width="90" align="center">
        <template slot-scope="scope">
          {{ formatStatMonth(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="platformVerifiedPoiSalesAmount"
        label="平台POI已核销券总销售金额"
        width="190"
        align="center"
      />
      <el-table-column
        prop="agentVerifiedPoiSalesAmount"
        label="团长已核销券总销售金额"
        width="190"
        align="center"
      />
      <el-table-column
        prop="nonCouponTransactionAmount"
        label="平台抖音团购非券订单成交金额(不含关单)"
        width="220"
        align="center"
      />
      <el-table-column prop="estimatedCommission" label="预估佣金" width="130" align="center" />
      <el-table-column label="实际结算佣金" width="140" align="center">
        <template slot-scope="scope">
          {{ scope.row.actualSettledCommission == null ? '' : scope.row.actualSettledCommission }}
        </template>
      </el-table-column>
      <el-table-column label="结算时间" width="180" align="center">
        <template slot-scope="scope">
          {{ scope.row.settlementTime || '' }}
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="tableList.total > 0"
      class="commission-detail__pagination"
      :current-page="params.pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableList.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </el-dialog>
</template>

<script>
import poi from '@/api/poi'

const PoiModel = new poi()

export default {
  name: 'NonCouponCommissionDetail',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      userUUID: '',
      dataUpdateTime: '',
      requestId: 0,
      params: {
        pageNo: 1,
        pageSize: 10
      },
      tableList: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        list: []
      }
    }
  },
  methods: {
    open(row) {
      this.resetState()
      if (!row || !row.userUUID) {
        this.$message.error('团长UUID不能为空')
        return
      }
      this.userUUID = row.userUUID
      this.dialogVisible = true
      this.getList()
    },
    async getList() {
      if (!this.userUUID) return
      const requestId = ++this.requestId
      const userUUID = this.userUUID
      this.loading = true
      try {
        const res = await PoiModel.getNonCouponCommissionDetailPage({
          userUUID,
          pageNo: this.params.pageNo,
          pageSize: this.params.pageSize
        })
        if (requestId !== this.requestId || userUUID !== this.userUUID) return
        if (res.data.code !== 200) {
          this.restorePagingParams()
          this.$message.error(res.data.message || '获取非券订单佣金明细失败')
          return
        }
        const data = res.data.data || {}
        const list = Array.isArray(data.list) ? data.list : []
        const currentPage = data.pageNo || this.params.pageNo
        const pageSize = data.pageSize || this.params.pageSize
        this.tableList.list = list
        this.tableList.total = data.total || 0
        this.tableList.currentPage = currentPage
        this.tableList.pageSize = pageSize
        this.params.pageNo = currentPage
        this.params.pageSize = pageSize
        if (currentPage === 1) {
          this.dataUpdateTime = list[0] && list[0].updateTime ? list[0].updateTime : ''
        }
      } catch (error) {
        if (requestId !== this.requestId || userUUID !== this.userUUID) return
        this.restorePagingParams()
        this.$message.error(error && error.message ? error.message : '获取非券订单佣金明细失败')
      } finally {
        if (requestId === this.requestId) {
          this.loading = false
        }
      }
    },
    formatStatMonth(row) {
      if (row.statYear == null || row.statMonth == null) return ''
      return `${row.statYear}年${row.statMonth}月`
    },
    restorePagingParams() {
      this.params.pageNo = this.tableList.currentPage
      this.params.pageSize = this.tableList.pageSize
    },
    handleSizeChange(value) {
      this.params.pageNo = 1
      this.params.pageSize = value
      this.getList()
    },
    handleCurrentChange(value) {
      this.params.pageNo = value
      this.getList()
    },
    resetState() {
      this.requestId += 1
      this.dialogVisible = false
      this.loading = false
      this.userUUID = ''
      this.dataUpdateTime = ''
      this.params.pageNo = 1
      this.params.pageSize = 10
      this.tableList.currentPage = 1
      this.tableList.pageSize = 10
      this.tableList.total = 0
      this.tableList.list = []
    }
  }
}
</script>

<style scoped lang="less">
.commission-detail {
  &__update-time {
    margin-bottom: 8px;
    color: #909399;
    font-size: 12px;
    text-align: right;
  }

  &__pagination {
    margin-top: 20px;
    text-align: right;
  }
}

/deep/ .non-coupon-commission-detail-dialog {
  max-width: calc(100vw - 32px);

  .el-dialog__body {
    max-height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/commissioSetting/nonCouponCommissionDetail.vue